import { render } from "./theme3.vue?vue&type=template&id=7f5c10ea&scoped=true"
import script from "./theme3.vue?vue&type=script&lang=js"
export * from "./theme3.vue?vue&type=script&lang=js"

import "./theme3.vue?vue&type=style&index=0&id=7f5c10ea&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7f5c10ea"

export default script